export const rolePermissions = (
  viewReservation,
  createReservation,
  adminReservation,
  edit_third_party_reservation,
  unlimitedReservation,
  shareReservation,
  manageAttributesReport,
  viewDriver,
  createDriver,
  editDriver,
  deleteDriver,
  viewCompany,
  editCompany,
  createUsers,
  editUsers,
  deleteUsers,
  editRoles,
  createVehicles,
  editVehicles,
  deleteVehicles,
  viewHistory,
  viewHistoryParams,
  showPrivateData,
  setPrivateVehicles,
  viewIoTKeylessAccess,
  editIoTKeylessAccess,
  keylessAccess,
  keylessAccessAdmin,
  giveKeylessAccess,
  editGroups,
  editModels,
  viewDiagnosis,
  viewReports,
  reportJobsAdmin,
  viewTacho,
  tachoDownload,
  tachoScheduler,
  getVehicles,
  getVehicleGroups,
  viewPortalFrontend,
  sendFeedback,
  viewIncidents,
  createIncidents,
  editIncidents,
  deleteIncidents,
  viewRadius,
  viewTraces,
  viewAccurateWidth,
  editVehicleToFollow,
  viewDashboards,
  viewEco,
  viewDriverRanking,
  createFleetbox,
  deleteFleetbox,
  editFleetbox,
  viewFleetboxModule,
  firmwareAdmin,
  viewInvoice,
  approveInvoice,
  releaseInvoice,
  viewActivity,
  viewOverview,
  viewFleetPage,
  viewVehicleTypes,
  createVehicleTypes,
  editVehicleTypes,
  deleteVehicleTypes,
  viewLogs,
  createLogs,
  rentalTariffsAdmin,
  rentalViewInvoices,
  rentalEditInvoices,
  sendSMSCommands,
  sendSMSCommandsAdmin,
  sendBridgeCommands,
  viewZones,
  createZones,
  editZones,
  deleteZones,
  viewDocuments,
  manageDocuments,
  deleteDocuments,
  manageReservationDocuments,
  customFieldsAdmin,
  viewResourcePlanner,
  viewContacts,
  createContacts,
  editContacts,
  deleteContacts,
  viewSearchByAttributes,
  viewReleaseInvoicePermission,
  releaseInvoiceDealerPermission,
  manageReleaseInvoicePermission,
  viewTags,
  createTags,
  editTags,
  deleteTags,
  viewLSVA,
  manualCorrectLSVA,
  revokeLSVA,
) => {
  return {
    vehicles_module: {
      view_module: true,
      get_vehicles: getVehicles,
      create_vehicle: createVehicles,
      edit_vehicle: editVehicles,
      delete_vehicle: deleteVehicles,
      view_history: viewHistory,
      view_history_params: viewHistoryParams,
      view_private_telemetry_data: showPrivateData,
      edit_private_state: setPrivateVehicles,
      get_vehicle_models: editModels || editVehicles,
      create_vehicle_model: editModels,
      edit_vehicle_model: editModels,
      delete_vehicle_model: editModels,
      get_vehicle_groups: getVehicleGroups,
      edit_vehicle_group: editGroups,
      delete_vehicle_group: editGroups,
      create_vehicle_group: editGroups,
      get_vehicle_tags: false,
      create_vehicle_tags: false,
      get_vehicle_types: viewVehicleTypes,
      create_vehicle_type: createVehicleTypes,
      edit_vehicle_type: editVehicleTypes,
      delete_vehicle_type: deleteVehicleTypes,
    },
    drivers_module: {
      view_module: viewDriver,
      get_drivers: viewDriver,
      create_driver: createDriver,
      edit_driver: editDriver,
      delete_driver: deleteDriver,
    },
    diagnosis_module: {
      view_module: viewDiagnosis,
    },
    iot_devices_module: {
      view_module: viewIoTKeylessAccess,
      manage_iot_devices: editIoTKeylessAccess,
    },
    reservation_module: {
      view_module: viewReservation,
      create_reservation: createReservation,
      edit_reservation: createReservation,
      create_interrupting_reservation: adminReservation,
      delete_reservation: createReservation,
      edit_third_party_reservation,
      unlimited_reservation: unlimitedReservation,
      share_reservation: shareReservation,
      manage_attributes_report: manageAttributesReport,
      keyless_access: keylessAccess,
      keyless_access_admin: keylessAccessAdmin,
      keyless_access_give_access: giveKeylessAccess,
    },
    reporting_module: {
      view_module: viewReports,
      report_jobs_admin: reportJobsAdmin,
    },
    tacho_module: {
      view_module: viewTacho,
      tacho_download: tachoDownload,
      tacho_scheduler: tachoScheduler,
    },
    company_settings_module: {
      view_module: viewCompany,
      edit_company_settings: editCompany,
      view_users: true,
      view_user_permissions: editRoles,
      add_user: createUsers,
      edit_user: editUsers,
      delete_user: deleteUsers,
      view_roles: true,
      add_role: editRoles,
      delete_role: editRoles,
      edit_role: editRoles,
    },
    frontend_module: {
      view_portal: viewPortalFrontend,
      send_feedback: sendFeedback,
    },
    incidents_module: {
      view_module: viewIncidents,
      create_incident: createIncidents,
      edit_incident: editIncidents,
      delete_incident: deleteIncidents,
    },
    radius_module: {
      view_module: viewRadius,
      view_traces: viewTraces,
      view_accurate_width: viewAccurateWidth,
      edit_vehicle_to_follow: editVehicleToFollow,
    },
    dashboard_module: {
      view_module: viewDashboards,
      view_eco: viewEco,
      view_driver_ranking: viewDriverRanking,
    },
    fleetbox_module: {
      view_module: viewFleetboxModule,
      create_fleetbox: createFleetbox,
      edit_fleetbox: editFleetbox,
      delete_fleetbox: deleteFleetbox,
      send_sms_command: sendSMSCommands,
      send_sms_command_admin: sendSMSCommandsAdmin,
      send_bridge_command: sendBridgeCommands,
      firmware_admin: firmwareAdmin,
    },
    invoice_module: {
      view_module: viewInvoice,
      approve_invoice: approveInvoice,
      release_invoice: releaseInvoice,
      view_release_invoice: viewReleaseInvoicePermission,
      release_invoice_dealer: releaseInvoiceDealerPermission,
      manage_release_invoice: manageReleaseInvoicePermission,
    },
    activity_module: {
      view_module: viewActivity,
    },
    fleet_module: {
      view_module: viewFleetPage,
    },
    overview_module: {
      view_module: viewOverview,
    },
    log_module: {
      view_module: viewLogs,
      create_log: createLogs,
    },
    rental_module: {
      rental_tariff_admin: rentalTariffsAdmin,
      view_invoices: rentalViewInvoices,
      edit_invoices: rentalEditInvoices,
    },
    geozones_module: {
      view_module: viewZones,
      create_zone: createZones,
      edit_zone: editZones,
      delete_zone: deleteZones,
    },
    documents_module: {
      view_module: viewDocuments,
      manage_document: manageDocuments,
      delete_document: deleteDocuments,
      manage_reservation_document: manageReservationDocuments,
    },
    custom_fields_module: {
      custom_fields_admin: customFieldsAdmin,
    },
    resource_planner_module: {
      view_module: viewResourcePlanner,
    },
    contacts_module: {
      view_module: viewContacts,
      create_contact: createContacts,
      edit_contact: editContacts,
      delete_contact: deleteContacts,
    },
    search_module: {
      view_search_by_attributes: viewSearchByAttributes,
    },
    tags_module: {
      view_module: viewTags,
      create_tag: createTags,
      edit_tag: editTags,
      delete_tag: deleteTags,
    },
    lsva_module: {
      view_module: viewLSVA,
      create_manual_corrections: manualCorrectLSVA,
      revoke_manual_corrections: revokeLSVA,
    },
  };
};
